<div class="flex flex-col gap-2 rounded-md border px-6 pt-4" *transloco="let t">
  <h4>
    <span>{{ t("dsp-audiences-type." + audienceType()) }}</span>
    <span class="type-label text-muted-foreground">
      - {{ t("dsp-audiences-type." + audienceType() + "_description") }}
    </span>
  </h4>
  <div class="type-body text-muted-foreground">
    {{ t("dsp-audience-lookback-config.select_one_or_more_lookback_periods") }}
  </div>
  <div class="flex flex-wrap gap-2">
    @for (lookbackConfig of allLookbacks(); track $index) {
      @let isSelected = lookbackConfig.isSelected;
      <span
        class="pointer type-label text-foreground flex gap-1 rounded-full border px-3 py-1.5 transition"
        iToggleButton
        [class.bg-main]="isSelected"
        [class.border-main-600]="isSelected"
        [class.text-main-foreground]="isSelected"
        [class.hover:bg-muted]="!isSelected"
        [isChecked]="isSelected"
        (isCheckedChange)="toggleLookback(lookbackConfig.lookback, $event)"
        ><span> {{ t("common.days_count", { count: lookbackConfig.lookback }) }}</span>
        @if (!lookbackConfig.isDefault) {
          <button iButton size="xs" variant="secondary" (click)="removeLookback(lookbackConfig.lookback)">
            <IIcon name="trash" />
          </button>
        }
      </span>
    }

    @if (isAddingCustomLookback()) {
      <div iInputGroup class="w-20">
        <input
          iInputGroupInput
          size="sm"
          [maxLength]="3"
          type="number"
          autofocus
          [(ngModel)]="lookbackBeingAdded"
          (focusout)="addCustomLookback()"
        />
        <span class="type-caption text-subtle-foreground" iInputGroupSuffix> days </span>
      </div>
    } @else {
      <button
        type="button"
        class="type-label text-foreground hover:bg-muted inline-flex items-center rounded-full border border-(--color-border-strong) px-3 py-1 transition"
        (click)="addCustomLookbackInput()"
      >
        <IIcon name="plus" />{{ t("common.add") }}
      </button>
    }
  </div>
  <div class="type-label text-destructive min-h-5">
    @if (lookbackBeingAdded() && lookbackBeingAdded()! > maxLookbacks[audienceType()]) {
      {{
        t("dsp-audience-lookback-config.audience_lookback_period_cannot_exceed", {
          audienceType: t("dsp-audiences-type." + audienceType()),
          max: maxLookbacks[audienceType()],
        })
      }}
    }
  </div>
  <div class="type-label text-muted-foreground min-h-6">
    @if (selectedLookbacks().length > 0) {
      {{
        t("dsp-audience-lookback-config.n_audiences_will_be_created", {
          count: selectedLookbacks().length,
          type: t("dsp-audiences-type." + audienceType()),
        })
      }}
    }
  </div>
</div>
